"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammaticReservationDto = exports.ProgrammaticMediaIngestionDto = exports.ProgrammaticOwnerRevocationDto = exports.ProgrammaticCapabilityObservationDto = exports.ProgrammaticBulkConfirmDto = exports.ProgrammaticBulkPreviewDto = exports.ProgrammaticEligibilityDto = exports.ProgrammaticPolicyPatchDto = exports.ProgrammaticPolicyDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const programmatic_type_1 = require("../../types/programmatic.type");
const programmatic_domain_1 = require("../../utils/programmatic-domain");
let RegistrableProgrammaticAdvertiserDomainConstraint = class RegistrableProgrammaticAdvertiserDomainConstraint {
    validate(value) {
        return (0, programmatic_domain_1.isRegistrableProgrammaticAdvertiserDomain)(value);
    }
};
RegistrableProgrammaticAdvertiserDomainConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "isRegistrableProgrammaticAdvertiserDomain", async: false })
], RegistrableProgrammaticAdvertiserDomainConstraint);
const normalizeStringList = (value, options = {}) => {
    if (!Array.isArray(value))
        return value;
    const normalized = value.map((item) => {
        if (options.advertiserDomains)
            return (0, programmatic_domain_1.normalizeProgrammaticAdvertiserDomain)(item);
        if (typeof item !== "string")
            return item;
        const trimmed = item.trim();
        return options.lowercase ? trimmed.toLowerCase() : trimmed;
    });
    return [...new Set(normalized)];
};
class ProgrammaticPolicyDto {
    enabled = false;
    slotsPerLoop = 0;
    minimumIntervalSeconds = programmatic_type_1.PROGRAMMATIC_MINIMUM_INTERVAL_SECONDS;
    blockedIabCategories = [];
    blockedAdvertiserDomains = [];
    blockedBrands = [];
    blockedCreativeIds = [];
    allowedMediaTypes = [...programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES];
    maxDurationSeconds = programmatic_type_1.PROGRAMMATIC_MAX_CREATIVE_DURATION_SECONDS;
    iabContentTaxonomyVersion = programmatic_type_1.PROGRAMMATIC_IAB_CONTENT_TAXONOMY_VERSION;
    iabContentTaxonomyId = programmatic_type_1.PROGRAMMATIC_IAB_CONTENT_TAXONOMY_ID;
}
exports.ProgrammaticPolicyDto = ProgrammaticPolicyDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Object)
], ProgrammaticPolicyDto.prototype, "enabled", void 0);
__decorate([
    (0, class_validator_1.IsIn)([0, 1]),
    __metadata("design:type", Number)
], ProgrammaticPolicyDto.prototype, "slotsPerLoop", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(programmatic_type_1.PROGRAMMATIC_MINIMUM_INTERVAL_SECONDS),
    __metadata("design:type", Object)
], ProgrammaticPolicyDto.prototype, "minimumIntervalSeconds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    (0, class_validator_1.MaxLength)(128, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyDto.prototype, "blockedIabCategories", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsFQDN)({ allow_trailing_dot: false, require_tld: true }, { each: true }),
    (0, class_validator_1.Validate)(RegistrableProgrammaticAdvertiserDomainConstraint, [], { each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    (0, class_validator_1.MaxLength)(253, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value, { advertiserDomains: true })),
    __metadata("design:type", Array)
], ProgrammaticPolicyDto.prototype, "blockedAdvertiserDomains", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    (0, class_validator_1.MaxLength)(128, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyDto.prototype, "blockedBrands", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    (0, class_validator_1.MaxLength)(128, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyDto.prototype, "blockedCreativeIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES.length),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsIn)(programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value, { lowercase: true })),
    __metadata("design:type", Array)
], ProgrammaticPolicyDto.prototype, "allowedMediaTypes", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(programmatic_type_1.PROGRAMMATIC_MAX_CREATIVE_DURATION_SECONDS),
    __metadata("design:type", Object)
], ProgrammaticPolicyDto.prototype, "maxDurationSeconds", void 0);
__decorate([
    (0, class_validator_1.IsIn)([programmatic_type_1.PROGRAMMATIC_IAB_CONTENT_TAXONOMY_VERSION]),
    __metadata("design:type", Object)
], ProgrammaticPolicyDto.prototype, "iabContentTaxonomyVersion", void 0);
__decorate([
    (0, class_validator_1.IsIn)([programmatic_type_1.PROGRAMMATIC_IAB_CONTENT_TAXONOMY_ID]),
    __metadata("design:type", Object)
], ProgrammaticPolicyDto.prototype, "iabContentTaxonomyId", void 0);
class ProgrammaticPolicyPatchDto {
    enabled;
    slotsPerLoop;
    minimumIntervalSeconds;
    blockedIabCategories;
    blockedAdvertiserDomains;
    blockedBrands;
    blockedCreativeIds;
    allowedMediaTypes;
    maxDurationSeconds;
}
exports.ProgrammaticPolicyPatchDto = ProgrammaticPolicyPatchDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], ProgrammaticPolicyPatchDto.prototype, "enabled", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)([0, 1]),
    __metadata("design:type", Number)
], ProgrammaticPolicyPatchDto.prototype, "slotsPerLoop", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(programmatic_type_1.PROGRAMMATIC_MINIMUM_INTERVAL_SECONDS),
    __metadata("design:type", Number)
], ProgrammaticPolicyPatchDto.prototype, "minimumIntervalSeconds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.MinLength)(1, { each: true }),
    (0, class_validator_1.MaxLength)(128, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyPatchDto.prototype, "blockedIabCategories", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsFQDN)({ allow_trailing_dot: false, require_tld: true }, { each: true }),
    (0, class_validator_1.Validate)(RegistrableProgrammaticAdvertiserDomainConstraint, [], { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value, { advertiserDomains: true })),
    __metadata("design:type", Array)
], ProgrammaticPolicyPatchDto.prototype, "blockedAdvertiserDomains", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyPatchDto.prototype, "blockedBrands", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MAX_POLICY_BLOCKS),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value)),
    __metadata("design:type", Array)
], ProgrammaticPolicyPatchDto.prototype, "blockedCreativeIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES.length),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsIn)(programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES, { each: true }),
    (0, class_transformer_1.Transform)(({ value }) => normalizeStringList(value, { lowercase: true })),
    __metadata("design:type", Array)
], ProgrammaticPolicyPatchDto.prototype, "allowedMediaTypes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(programmatic_type_1.PROGRAMMATIC_MAX_CREATIVE_DURATION_SECONDS),
    __metadata("design:type", Number)
], ProgrammaticPolicyPatchDto.prototype, "maxDurationSeconds", void 0);
class ProgrammaticEligibilityDto {
    eligible;
}
exports.ProgrammaticEligibilityDto = ProgrammaticEligibilityDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], ProgrammaticEligibilityDto.prototype, "eligible", void 0);
class ProgrammaticBulkPreviewDto {
    displayIds;
    allOwned;
    ownerId;
    mode = "add";
    patch;
}
exports.ProgrammaticBulkPreviewDto = ProgrammaticBulkPreviewDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(programmatic_type_1.PROGRAMMATIC_BULK_MAX_EXPLICIT_DISPLAYS),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)({ each: true }),
    __metadata("design:type", Array)
], ProgrammaticBulkPreviewDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], ProgrammaticBulkPreviewDto.prototype, "allOwned", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticBulkPreviewDto.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["add", "replace", "clear"]),
    __metadata("design:type", String)
], ProgrammaticBulkPreviewDto.prototype, "mode", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ProgrammaticPolicyPatchDto),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", ProgrammaticPolicyPatchDto)
], ProgrammaticBulkPreviewDto.prototype, "patch", void 0);
class ProgrammaticBulkConfirmDto {
    previewToken;
    idempotencyKey;
    confirmation;
}
exports.ProgrammaticBulkConfirmDto = ProgrammaticBulkConfirmDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticBulkConfirmDto.prototype, "previewToken", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticBulkConfirmDto.prototype, "idempotencyKey", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["CONFIRM"]),
    __metadata("design:type", String)
], ProgrammaticBulkConfirmDto.prototype, "confirmation", void 0);
class ProgrammaticCapabilityObservationDto {
    capabilities;
}
exports.ProgrammaticCapabilityObservationDto = ProgrammaticCapabilityObservationDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsIn)([programmatic_type_1.PROGRAMMATIC_PLAYER_CAPABILITY], { each: true }),
    __metadata("design:type", Array)
], ProgrammaticCapabilityObservationDto.prototype, "capabilities", void 0);
class ProgrammaticOwnerRevocationDto {
    idempotencyKey;
}
exports.ProgrammaticOwnerRevocationDto = ProgrammaticOwnerRevocationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticOwnerRevocationDto.prototype, "idempotencyKey", void 0);
class ProgrammaticMediaIngestionDto {
    ownerId;
    providerId;
    providerCreativeId;
    contentHash;
    mediaType;
    mimeType;
    bytesBase64;
    width;
    height;
    durationSeconds;
}
exports.ProgrammaticMediaIngestionDto = ProgrammaticMediaIngestionDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "providerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "providerCreativeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "contentHash", void 0);
__decorate([
    (0, class_validator_1.IsIn)(programmatic_type_1.PROGRAMMATIC_MEDIA_TYPES),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "mediaType", void 0);
__decorate([
    (0, class_validator_1.IsIn)(["image/png", "image/jpeg", "video/mp4"]),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "mimeType", void 0);
__decorate([
    (0, class_validator_1.IsBase64)(),
    (0, class_validator_1.MaxLength)(20_000_000),
    __metadata("design:type", String)
], ProgrammaticMediaIngestionDto.prototype, "bytesBase64", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], ProgrammaticMediaIngestionDto.prototype, "width", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], ProgrammaticMediaIngestionDto.prototype, "height", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(programmatic_type_1.PROGRAMMATIC_MAX_CREATIVE_DURATION_SECONDS),
    __metadata("design:type", Number)
], ProgrammaticMediaIngestionDto.prototype, "durationSeconds", void 0);
class ProgrammaticReservationDto {
    displayId;
    reservationKey;
    capabilities;
    completedNormalLoop;
    directCampaignActive;
}
exports.ProgrammaticReservationDto = ProgrammaticReservationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticReservationDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(128),
    __metadata("design:type", String)
], ProgrammaticReservationDto.prototype, "reservationKey", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsIn)([programmatic_type_1.PROGRAMMATIC_PLAYER_CAPABILITY], { each: true }),
    __metadata("design:type", Array)
], ProgrammaticReservationDto.prototype, "capabilities", void 0);
__decorate([
    (0, class_validator_1.Equals)(true),
    __metadata("design:type", Boolean)
], ProgrammaticReservationDto.prototype, "completedNormalLoop", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], ProgrammaticReservationDto.prototype, "directCampaignActive", void 0);
